import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const SECURITY_CLUSTERS_SETTINGS_QUERY_KEY = 'security-clusters-settings';

export const getSecurityClustersSettingsQueryKey = (clusterId?: string) =>
  clusterId
    ? ([SECURITY_CLUSTERS_SETTINGS_QUERY_KEY, clusterId] as const)
    : ([SECURITY_CLUSTERS_SETTINGS_QUERY_KEY] as const);

const getSecurityClustersSettingsQueryOptions = () =>
  queryOptions({
    queryKey: getSecurityClustersSettingsQueryKey(),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getClustersSettings();
      return data;
    },
  });

export const useSecurityClustersSettings = () => {
  const {
    data: settings,
    isLoading,
    error,
    refetch,
  } = useQuery(getSecurityClustersSettingsQueryOptions());
  return { settings, isLoading, error, refetch };
};
